import MonetaryValue from './MonetaryValue';

export default MonetaryValue;
